import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import NormalizedInput from '..';

class Email extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const { name, onChange } = this.props;
    onChange(name, e.target.value);
  }

  render() {
    const { handleChange } = this;
    const { className } = this.props;
    return (
      <NormalizedInput>
        <input
          {...this.props}
          className={`Email ${className}`}
          type="email"
          onChange={handleChange}
        />
      </NormalizedInput>
    );
  }
}

Email.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

Email.defaultProps = {
  className: '',
  onChange: noop,
  value: '',
};

export default Email;
